import { Dispatch } from "react";
import * as actionTypes from "../actionTypes/Index";
import {
  ICreateOrderPayload,
  IActionType,
  IGetQueryParams,
  IFetchOrderActionResponse,
  IOrderDetailResponseNormalized,
  IUpdateOrderPayload,
  IUpdateOrderStatusPayload,
  IActivePromosForOrderPayload,
  IOrderPriceBreakdown,
} from "../../interfaces/Index";
import {
  createOrderApiCall,
  fetchOrdersApiCall,
  fetchOrdersDetailsApiCall,
  updateOrderApiCall,
  updateOrderStatusApiCall,
  fetchPromosForOrderApiCall,
  fetchOrderPriceBreakdownApiCall,
} from "../sources/OrderSource";

export const createOrderInit = () => ({
  type: actionTypes.CREATE_ORDER_INIT,
});

export const createOrderSuccess = () => ({
  type: actionTypes.CREATE_ORDER_SUCCESS,
});

export const createOrderFail = (error: string | object | null) => ({
  type: actionTypes.CREATE_ORDER_FAIL,
  error,
});

export const fetchOrderInit = () => ({
  type: actionTypes.GET_ORDERS_INIT,
});

export const fetchOrderSuccess = (
  payload: IFetchOrderActionResponse | null
) => ({
  type: actionTypes.GET_ORDERS_SUCCESS,
  payload,
});

export const fetchOrderFail = (error: string | object | null) => ({
  type: actionTypes.GET_ORDERS_FAIL,
  error,
});

export const fetchOrderPriceBreakdownInit = () => ({
  type: actionTypes.GET_ORDER_PRICE_BREAKDOWN_INIT,
});

export const fetchOrderPriceBreakdownSuccess = (
  payload: IOrderPriceBreakdown | null
) => ({
  type: actionTypes.GET_ORDER_PRICE_BREAKDOWN_SUCCESS,
  payload,
});

export const fetchOrderPriceBreakdownFail = (
  error: string | object | null
) => ({
  type: actionTypes.GET_ORDER_PRICE_BREAKDOWN_FAIL,
  error,
});

export const fetchOrderDetailsInit = () => ({
  type: actionTypes.GET_ORDERS_DETAILS_INIT,
});

export const fetchOrderDetailsSuccess = (
  payload: IOrderDetailResponseNormalized
) => ({
  type: actionTypes.GET_ORDERS_DETAILS_SUCCESS,
  payload,
});

export const fetchOrderDetailsFail = (error: string | object | null) => ({
  type: actionTypes.GET_ORDERS_DETAILS_FAIL,
  error,
});

export const clearOrderDetails = () => ({
  type: actionTypes.CLEAR_ORDER_DETAILS,
});

export const orderUpdateInit = () => ({
  type: actionTypes.UPDATE_ORDER_INIT,
});

export const orderUpdateSuccess = () => ({
  type: actionTypes.UPDATE_ORDER_SUCCESS,
});

export const orderUpdateFail = (error: string | object | null) => ({
  type: actionTypes.UPDATE_ORDER_FAIL,
  error,
});

export const orderUpdateStatusInit = () => ({
  type: actionTypes.UPDATE_ORDER_STATUS_INIT,
});

export const orderUpdateStatusSuccess = () => ({
  type: actionTypes.UPDATE_ORDER_STATUS_SUCCESS,
});

export const orderUpdateStatusFail = (error: string | object | null) => ({
  type: actionTypes.UPDATE_ORDER_STATUS_FAIL,
  error,
});

export const fetchPromosForOrderInit = () => ({
  type: actionTypes.GET_PROMOS_FOR_ORDER_INIT,
});

export const fetchPromosForOrderSuccess = (
  payload: IActivePromosForOrderPayload
) => ({
  type: actionTypes.GET_PROMOS_FOR_ORDER_SUCCESS,
  payload,
});

export const fetchPromosForOrderFail = (error: string | object | null) => ({
  type: actionTypes.GET_PROMOS_FOR_ORDER_FAIL,
  error,
});

// async actions
export const createOrder =
  (payload: ICreateOrderPayload) => (dispatch: Dispatch<IActionType>) => {
    dispatch(createOrderInit());
    return createOrderApiCall(payload)
      .then(() => dispatch(createOrderSuccess()))
      .catch((e: object | null | string) => dispatch(createOrderFail(e)));
  };

export const getOrders =
  (queryParams?: IGetQueryParams) => (dispatch: Dispatch<IActionType>) => {
    dispatch(fetchOrderInit());
    return fetchOrdersApiCall(queryParams)
      .then((orders: IFetchOrderActionResponse) =>
        dispatch(fetchOrderSuccess(orders))
      )
      .catch((e: object | null | string) => dispatch(fetchOrderFail(e)));
  };

export const getOrderDetails =
  (id: string) => (dispatch: Dispatch<IActionType>) => {
    dispatch(fetchOrderDetailsInit());
    return fetchOrdersDetailsApiCall(id)
      .then((details: IOrderDetailResponseNormalized) =>
        dispatch(fetchOrderDetailsSuccess(details))
      )
      .catch((e: object | null | string) => dispatch(fetchOrderDetailsFail(e)));
  };

export const clearOrderDetailsAction =
  () => (dispatch: Dispatch<IActionType>) => {
    return dispatch(clearOrderDetails());
  };

export const updateOrder =
  (id: string, payload: IUpdateOrderPayload) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(orderUpdateInit());
    return updateOrderApiCall(id, payload)
      .then(() => dispatch(orderUpdateSuccess()))
      .catch((e: object | null | string) => dispatch(orderUpdateFail(e)));
  };

export const updateOrderStatus =
  (id: string, payload: IUpdateOrderStatusPayload) =>
  (dispatch: Dispatch<IActionType>) => {
    dispatch(orderUpdateStatusInit());
    return updateOrderStatusApiCall(id, payload)
      .then(() => dispatch(orderUpdateStatusSuccess()))
      .catch((e: object | null | string) => dispatch(orderUpdateStatusFail(e)));
  };

export const getPromosForOrder = () => (dispatch: Dispatch<IActionType>) => {
  dispatch(fetchPromosForOrderInit());
  return fetchPromosForOrderApiCall()
    .then((promos: IActivePromosForOrderPayload) =>
      dispatch(fetchPromosForOrderSuccess(promos))
    )
    .catch((e: object | null | string) => dispatch(fetchPromosForOrderFail(e)));
};

export const getOrderPriceBreakdown =
  (queryParams?: IGetQueryParams) => (dispatch: Dispatch<IActionType>) => {
    dispatch(fetchOrderPriceBreakdownInit());
    return fetchOrderPriceBreakdownApiCall(queryParams)
      .then((orderPriceBreakdown) =>
        dispatch(fetchOrderPriceBreakdownSuccess(orderPriceBreakdown))
      )
      .catch((e: object | null | string) =>
        dispatch(fetchOrderPriceBreakdownFail(e))
      );
  };
